<h3 class="mb-3" i18n="@@ehsWithAbbreviation" t="ehsWithAbbreviation">Environment, Health, and Safety (EHS)</h3>
<div class="col right top-buttons">
    <button
    tsl-button
    size="small"
    color="black"
    outline
    (click)="showHistory()"
    i18n="@@2919237623258423230" t="2919237623258423230"
    #historyButton 
>History</button>
<!-- todo ttp -->
<button
    tsl-button
    *ngIf="editPermission"
    [disabled]="preventativeHold==true"
    size="small"
    color="blue"
    (click)="allowEdit()"
    i18n="@@editehsresponses" t="editehsresponses"
    #editEHSresponses
>Edit Responses</button>
</div>
<div class="inside-container">
    <ehs-edit *ngIf="formSchema && formData" 
    #ehsEdit 
    [tsl-supplierCode]="supplierCode" 
    [tsl-formSchema]="formSchema"
    [tsl-formData]="formData" 
    [tsl-readOnly]="isReadOnly"></ehs-edit>
</div>
<div class="col right bottom-buttons">
    <button
    tsl-button
    [disabled]="!enableSubmit  || preventativeHold==true"
    size="small"
    color="blue"
    (click)="onSubmitClick()"
    i18n="@@Submit" t="Submit"
    #submitButton
>Submit</button>
    <button
    tsl-button
    [disabled]="!enableSubmit"
    size="small"
    color="black"
    outline
    (click)="cancel()"
    i18n="@@Cancel" t="Cancel"
    #cancelButton 
>Cancel</button>

</div>